import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Icon1h1pe6893iwt2 as Icon,
} from '../models/data.mjs';
import {
  align1ejncrrer3meh as align,
  weightt34o7llf2uyq as weight,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from './direct/modifiers.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
  ReactiveLoadings35224pps2d9 as ReactiveLoading,
} from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  LateInitSignal30crwrg540xyy as LateInitSignal,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from './RView.js.mjs';
import { set_value1vvx5pkb20ebv as set_value } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../models/data.commonHtml.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { afterTimeout2ddqxaabn39mu as afterTimeout } from '../afterTimeout.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../ViewWrapper.mjs';
import { _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from './ViewWriter.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_centered(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Center_getInstance(), Align_Center_getInstance());
}
function get_atStart(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Start_getInstance(), Align_Stretch_getInstance());
}
function get_expanding(_this__u8e3s4) {
  return weight(_this__u8e3s4, 1.0);
}
function get_atEnd(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_End_getInstance(), Align_Stretch_getInstance());
}
function forEach(_this__u8e3s4, items, render) {
  reactiveScope(_this__u8e3s4, ($this$reactiveScope) => {
    _this__u8e3s4.bba();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = $this$reactiveScope.daj(items).m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      render(_this__u8e3s4, element);
    }
    return Unit_instance;
  });
}
function get_atTopEnd(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_End_getInstance(), Align_Start_getInstance());
}
function forEachAnimated(_this__u8e3s4, items, preHidingModifiers, render) {
  var tmp;
  if (preHidingModifiers === VOID) {
    tmp = forEachAnimated$lambda;
  } else {
    tmp = preHidingModifiers;
  }
  preHidingModifiers = tmp;
  var oldEarly = ArrayList().w();
  var old = oldEarly instanceof ArrayList() ? oldEarly : THROW_CCE();
  reactive(_this__u8e3s4, ($this$reactive) => {
    var new_0 = $this$reactive.daj(items);
    var oldPos = {_v: 0};
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = new_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var matchIndex = -1;
      var inductionVariable = oldPos._v;
      var last = old.p1();
      if (inductionVariable < last)
        $l$loop: do {
          var checkIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals(old.q1(checkIndex).cdc_1, item)) {
            old.q1(checkIndex).idc();
            matchIndex = checkIndex;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
      if (!(matchIndex === -1)) {
        var inductionVariable_0 = oldPos._v;
        var last_0 = matchIndex;
        if (inductionVariable_0 < last_0)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            old.q1(index_1).jdc();
          }
           while (inductionVariable_0 < last_0);
        oldPos._v = matchIndex + 1 | 0;
      } else {
        var shown = Signal().hak(false);
        var indexWriter = new (forEachAnimated$4$1())(_this__u8e3s4, oldPos);
        // Inline function 'kotlin.with' call
        var tmp = preHidingModifiers(indexWriter, item);
        var view = indexWriter.lbb(indexWriter.kbb(tmp, shownWhen(indexWriter, VOID, forEachAnimated$lambda$lambda(shown))), render(indexWriter, item));
        old.y3(oldPos._v, new (forEachAnimated$OldViewInfo())(_this__u8e3s4, oldEarly, index_0, item, view.cba(), shown));
        shown.oam(true);
        oldPos._v = oldPos._v + 1 | 0;
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = old.m3(oldPos._v, old.p1()).m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element = _iterator__ex2g4s_0.o1();
      element.jdc();
    }
    return Unit_instance;
  });
}
function forEachUpdating(_this__u8e3s4, items, placeholdersWhileLoading, render) {
  placeholdersWhileLoading = placeholdersWhileLoading === VOID ? 5 : placeholdersWhileLoading;
  var currentViews = ArrayList().w();
  var currentView = _this__u8e3s4;
  // Inline function 'com.lightningkite.reactive.context.reactiveScope' call
  // Inline function 'com.lightningkite.reactive.context.reactive' call
  var wasLoadingLastTime = {_v: false};
  reactive(_this__u8e3s4, ($this$reactive) => {
    var tmp;
    try {
      var itemList = $this$reactive.daj(items);
      // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
      var tmp_0 = currentView.vb5_1.xb3_1;
      var tmp0_safe_receiver = tmp_0 instanceof HTMLElement ? tmp_0 : null;
      var tmp_1;
      if (tmp0_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
        var this_0 = tmp0_safe_receiver;
        var animate = get_animationsEnabled();
        try {
          if (animate) {
            set_animationsEnabled(false);
            // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp_2 = this_0.__suppressMutationObserverClass;
            var tmp0_elvis_lhs = tmp_2 instanceof ArrayList() ? tmp_2 : null;
            var tmp_3;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.run' call
              var n = ArrayList().w();
              // Inline function 'kotlin.js.asDynamic' call
              this_0.__suppressMutationObserverClass = n;
              tmp_3 = n;
            } else {
              tmp_3 = tmp0_elvis_lhs;
            }
            var e = tmp_3;
            this_0.classList.add('notransition');
            var tmp1_elvis_lhs = this_0.getAttribute('class');
            e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
          }
          var oldCurrentViewsSize = currentViews.p1();
          if (currentViews.p1() < itemList.p1()) {
            // Inline function 'kotlin.repeat' call
            var times = itemList.p1() - currentViews.p1() | 0;
            var inductionVariable = 0;
            if (inductionVariable < times)
              do {
                var index = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var newProp = LateInitSignal().taq();
                set_value(newProp, itemList.q1(currentViews.p1()));
                render(_this__u8e3s4, newProp);
                currentViews.v(newProp);
              }
               while (inductionVariable < times);
          }
          var children = currentView.qba();
          var inductionVariable_0 = 0;
          // Inline function 'kotlin.math.min' call
          var b = itemList.p1();
          var last = Math.min(oldCurrentViewsSize, b);
          if (inductionVariable_0 < last)
            do {
              var index_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              children.q1(index_0).jb7(true);
              set_value(currentViews.q1(index_0), itemList.q1(index_0));
            }
             while (inductionVariable_0 < last);
          var inductionVariable_1 = itemList.p1();
          var last_0 = currentViews.p1();
          if (inductionVariable_1 < last_0)
            do {
              var index_1 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              children.q1(index_1).jb7(false);
            }
             while (inductionVariable_1 < last_0);
        }finally {
          if (animate) {
            var tmp_4 = window;
            tmp_4.setTimeout(() => {
              // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
              var this_1 = this_0;
              // Inline function 'kotlin.js.asDynamic' call
              var tmp = this_1.__suppressMutationObserverClass;
              var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.run' call
                var n = ArrayList().w();
                // Inline function 'kotlin.js.asDynamic' call
                this_1.__suppressMutationObserverClass = n;
                tmp_0 = n;
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              var e = tmp_0;
              this_0.classList.remove('notransition');
              var tmp1_elvis_lhs = this_1.getAttribute('class');
              e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
              return Unit_instance;
            }, 100);
            set_animationsEnabled(true);
          }
        }
        tmp_1 = Unit_instance;
      }
      if (tmp_1 == null) {
        var oldCurrentViewsSize_0 = currentViews.p1();
        if (currentViews.p1() < itemList.p1()) {
          // Inline function 'kotlin.repeat' call
          var times_0 = itemList.p1() - currentViews.p1() | 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < times_0)
            do {
              var index_2 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var newProp_0 = LateInitSignal().taq();
              set_value(newProp_0, itemList.q1(currentViews.p1()));
              render(_this__u8e3s4, newProp_0);
              currentViews.v(newProp_0);
            }
             while (inductionVariable_2 < times_0);
        }
        var children_0 = currentView.qba();
        var inductionVariable_3 = 0;
        // Inline function 'kotlin.math.min' call
        var b_0 = itemList.p1();
        var last_1 = Math.min(oldCurrentViewsSize_0, b_0);
        if (inductionVariable_3 < last_1)
          do {
            var index_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            children_0.q1(index_3).jb7(true);
            set_value(currentViews.q1(index_3), itemList.q1(index_3));
          }
           while (inductionVariable_3 < last_1);
        var inductionVariable_4 = itemList.p1();
        var last_2 = currentViews.p1();
        if (inductionVariable_4 < last_2)
          do {
            var index_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            children_0.q1(index_4).jb7(false);
          }
           while (inductionVariable_4 < last_2);
      }
      wasLoadingLastTime._v = false;
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_5;
      if ($p instanceof ReactiveLoading()) {
        var e_0 = $p;
        if (wasLoadingLastTime._v) {
          $l$block_0: {
            // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
            var tmp_6 = currentView.vb5_1.xb3_1;
            var tmp0_safe_receiver_0 = tmp_6 instanceof HTMLElement ? tmp_6 : null;
            var tmp_7;
            if (tmp0_safe_receiver_0 == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
              var this_1 = tmp0_safe_receiver_0;
              var animate_0 = get_animationsEnabled();
              try {
                if (animate_0) {
                  set_animationsEnabled(false);
                  // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                  // Inline function 'kotlin.js.asDynamic' call
                  var tmp_8 = this_1.__suppressMutationObserverClass;
                  var tmp0_elvis_lhs_0 = tmp_8 instanceof ArrayList() ? tmp_8 : null;
                  var tmp_9;
                  if (tmp0_elvis_lhs_0 == null) {
                    // Inline function 'kotlin.run' call
                    var n_0 = ArrayList().w();
                    // Inline function 'kotlin.js.asDynamic' call
                    this_1.__suppressMutationObserverClass = n_0;
                    tmp_9 = n_0;
                  } else {
                    tmp_9 = tmp0_elvis_lhs_0;
                  }
                  var e_1 = tmp_9;
                  this_1.classList.add('notransition');
                  var tmp1_elvis_lhs_0 = this_1.getAttribute('class');
                  e_1.v(tmp1_elvis_lhs_0 == null ? '' : tmp1_elvis_lhs_0);
                }
                if (placeholdersWhileLoading <= 0) {
                  break $l$block_0;
                }
                if (currentViews.p1() < placeholdersWhileLoading) {
                  // Inline function 'kotlin.repeat' call
                  var times_1 = placeholdersWhileLoading - currentViews.p1() | 0;
                  var inductionVariable_5 = 0;
                  if (inductionVariable_5 < times_1)
                    do {
                      var index_5 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      var newProp_1 = LateInitSignal().taq();
                      render(_this__u8e3s4, newProp_1);
                      currentViews.v(newProp_1);
                    }
                     while (inductionVariable_5 < times_1);
                }
                var children_1 = currentView.qba();
                var inductionVariable_6 = 0;
                if (inductionVariable_6 < placeholdersWhileLoading)
                  do {
                    var index_6 = inductionVariable_6;
                    inductionVariable_6 = inductionVariable_6 + 1 | 0;
                    children_1.q1(index_6).jb7(true);
                    currentViews.q1(index_6).uaq();
                  }
                   while (inductionVariable_6 < placeholdersWhileLoading);
                var inductionVariable_7 = placeholdersWhileLoading;
                var last_3 = currentViews.p1();
                if (inductionVariable_7 < last_3)
                  do {
                    var index_7 = inductionVariable_7;
                    inductionVariable_7 = inductionVariable_7 + 1 | 0;
                    children_1.q1(index_7).jb7(false);
                  }
                   while (inductionVariable_7 < last_3);
              }finally {
                if (animate_0) {
                  var tmp_10 = window;
                  tmp_10.setTimeout(() => {
                    // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                    var this_0 = this_1;
                    // Inline function 'kotlin.js.asDynamic' call
                    var tmp = this_0.__suppressMutationObserverClass;
                    var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
                    var tmp_0;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'kotlin.run' call
                      var n = ArrayList().w();
                      // Inline function 'kotlin.js.asDynamic' call
                      this_0.__suppressMutationObserverClass = n;
                      tmp_0 = n;
                    } else {
                      tmp_0 = tmp0_elvis_lhs;
                    }
                    var e = tmp_0;
                    this_1.classList.remove('notransition');
                    var tmp1_elvis_lhs = this_0.getAttribute('class');
                    e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                    return Unit_instance;
                  }, 100);
                  set_animationsEnabled(true);
                }
              }
              tmp_7 = Unit_instance;
            }
            if (tmp_7 == null) {
              if (placeholdersWhileLoading <= 0) {
                break $l$block_0;
              }
              if (currentViews.p1() < placeholdersWhileLoading) {
                // Inline function 'kotlin.repeat' call
                var times_2 = placeholdersWhileLoading - currentViews.p1() | 0;
                var inductionVariable_8 = 0;
                if (inductionVariable_8 < times_2)
                  do {
                    var index_8 = inductionVariable_8;
                    inductionVariable_8 = inductionVariable_8 + 1 | 0;
                    var newProp_2 = LateInitSignal().taq();
                    render(_this__u8e3s4, newProp_2);
                    currentViews.v(newProp_2);
                  }
                   while (inductionVariable_8 < times_2);
              }
              var children_2 = currentView.qba();
              var inductionVariable_9 = 0;
              if (inductionVariable_9 < placeholdersWhileLoading)
                do {
                  var index_9 = inductionVariable_9;
                  inductionVariable_9 = inductionVariable_9 + 1 | 0;
                  children_2.q1(index_9).jb7(true);
                  currentViews.q1(index_9).uaq();
                }
                 while (inductionVariable_9 < placeholdersWhileLoading);
              var inductionVariable_10 = placeholdersWhileLoading;
              var last_4 = currentViews.p1();
              if (inductionVariable_10 < last_4)
                do {
                  var index_10 = inductionVariable_10;
                  inductionVariable_10 = inductionVariable_10 + 1 | 0;
                  children_2.q1(index_10).jb7(false);
                }
                 while (inductionVariable_10 < last_4);
            }
          }
          wasLoadingLastTime._v = true;
        }
        throw e_0;
      } else {
        if ($p instanceof Exception()) {
          var e_2 = $p;
          wasLoadingLastTime._v = false;
          tmp_5 = Unit_instance;
        } else {
          throw $p;
        }
      }
      tmp = tmp_5;
    }
    return Unit_instance;
  });
}
function get_empty(_this__u8e3s4) {
  var tmp = get_rem(2);
  var tmp_0 = get_rem(2);
  // Inline function 'kotlin.collections.listOf' call
  var tmp$ret$0 = emptyList();
  return new (Icon())(tmp, tmp_0, 0, -960, 960, 960, tmp$ret$0);
}
function get_atCenterStart(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Start_getInstance(), Align_Center_getInstance());
}
function get_atTopStart(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Start_getInstance(), Align_Start_getInstance());
}
function get_atBottom(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Stretch_getInstance(), Align_End_getInstance());
}
function get_atTopCenter(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Center_getInstance(), Align_Start_getInstance());
}
function get_atTop(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Stretch_getInstance(), Align_Start_getInstance());
}
function get_atCenterEnd(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_End_getInstance(), Align_Center_getInstance());
}
function get_atBottomCenter(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Center_getInstance(), Align_End_getInstance());
}
function get_atBottomEnd(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_End_getInstance(), Align_End_getInstance());
}
function forEachById(_this__u8e3s4, items, id, preHidingModifiers, render) {
  var tmp;
  if (preHidingModifiers === VOID) {
    tmp = forEachById$lambda;
  } else {
    tmp = preHidingModifiers;
  }
  preHidingModifiers = tmp;
  var oldEarly = ArrayList().w();
  var old = oldEarly instanceof ArrayList() ? oldEarly : THROW_CCE();
  reactive(_this__u8e3s4, ($this$reactive) => {
    var new_0 = $this$reactive.daj(items);
    var oldPos = {_v: 0};
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = new_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      var matchIndex = -1;
      var inductionVariable = oldPos._v;
      var last = old.p1();
      if (inductionVariable < last)
        $l$loop: do {
          var checkIndex = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (equals(old.q1(checkIndex).ldc_1, id(item))) {
            matchIndex = checkIndex;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
      if (!(matchIndex === -1)) {
        var inductionVariable_0 = oldPos._v;
        var last_0 = matchIndex;
        if (inductionVariable_0 < last_0)
          do {
            var index_1 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            old.q1(index_1).jdc();
          }
           while (inductionVariable_0 < last_0);
        oldPos._v = matchIndex + 1 | 0;
        // Inline function 'kotlin.let' call
        var it = old.q1(matchIndex);
        it.mdc_1.oam(item);
        it.idc();
      } else {
        var shown = Signal().hak(false);
        var data = Signal().hak(item);
        var indexWriter = new (forEachById$4$1())(_this__u8e3s4, oldPos);
        // Inline function 'kotlin.with' call
        var tmp = preHidingModifiers(indexWriter, id(item));
        var view = indexWriter.lbb(indexWriter.kbb(tmp, shownWhen(indexWriter, VOID, forEachById$lambda$lambda(shown))), render(indexWriter, data));
        old.y3(oldPos._v, new (forEachById$OldViewInfo())(_this__u8e3s4, oldEarly, index_0, id(item), data, view.cba(), shown));
        afterTimeout($this$reactive, 1n, forEachById$lambda$lambda_0(shown));
        oldPos._v = oldPos._v + 1 | 0;
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = old.m3(oldPos._v, old.p1()).m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element = _iterator__ex2g4s_0.o1();
      element.jdc();
    }
    return Unit_instance;
  });
}
function get_atBottomStart(_this__u8e3s4) {
  return align(_this__u8e3s4, Align_Start_getInstance(), Align_End_getInstance());
}
function forEachAnimated$lambda(_this__u8e3s4, it) {
  return Companion_getInstance();
}
var forEachAnimated$OldViewInfoClass;
function forEachAnimated$OldViewInfo() {
  if (forEachAnimated$OldViewInfoClass === VOID) {
    class $ {
      constructor($this_forEachAnimated, $oldEarly, oldIndex, data, view, shown) {
        this.gdc_1 = $this_forEachAnimated;
        this.hdc_1 = $oldEarly;
        this.bdc_1 = oldIndex;
        this.cdc_1 = data;
        this.ddc_1 = view;
        this.edc_1 = shown;
        this.fdc_1 = 0;
      }
      idc() {
        this.fdc_1 = this.fdc_1 + 1 | 0;
        this.edc_1.oam(true);
      }
      jdc() {
        this.fdc_1 = this.fdc_1 + 1 | 0;
        var n = this.fdc_1;
        this.edc_1.oam(false);
        // Inline function 'kotlin.Long.plus' call
        var this_0 = _Duration___get_inWholeMilliseconds__impl__msfiry(this.ddc_1.mba().vb0_1);
        var tmp = add(this_0, fromInt(100));
        afterTimeout(this.gdc_1, tmp, () => {
          var tmp;
          if (n === this.fdc_1) {
            this.gdc_1.uba(this.ddc_1);
            this.hdc_1.w3(this);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
      }
      toString() {
        return 'OldViewInfo(oldIndex=' + this.bdc_1 + ', data=' + toString_0(this.cdc_1) + ', view=' + this.ddc_1.toString() + ', shown=' + toString(this.edc_1) + ')';
      }
      hashCode() {
        var result = this.bdc_1;
        result = imul(result, 31) + (this.cdc_1 == null ? 0 : hashCode(this.cdc_1)) | 0;
        result = imul(result, 31) + hashCode(this.ddc_1) | 0;
        result = imul(result, 31) + hashCode(this.edc_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof forEachAnimated$OldViewInfo()))
          return false;
        if (!(this.bdc_1 === other.bdc_1))
          return false;
        if (!equals(this.cdc_1, other.cdc_1))
          return false;
        if (!equals(this.ddc_1, other.ddc_1))
          return false;
        if (!equals(this.edc_1, other.edc_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'OldViewInfo');
    forEachAnimated$OldViewInfoClass = $;
  }
  return forEachAnimated$OldViewInfoClass;
}
var forEachAnimated$4$1Class;
function forEachAnimated$4$1() {
  if (forEachAnimated$4$1Class === VOID) {
    class $ extends ViewWriter() {
      constructor($this_forEachAnimated, $oldPos, $box) {
        if ($box === VOID)
          $box = {};
        $box.udc_1 = $this_forEachAnimated;
        $box.vdc_1 = $oldPos;
        super($box);
      }
      pc() {
        return this.udc_1.pc();
      }
      ga2() {
        return this.udc_1.ga2();
      }
      tba(view) {
        this.udc_1.sba(this.vdc_1._v, view);
      }
      rba(view) {
        this.udc_1.rba(view);
      }
    }
    initMetadataForClass($);
    forEachAnimated$4$1Class = $;
  }
  return forEachAnimated$4$1Class;
}
function forEachAnimated$lambda$lambda($shown) {
  return ($this$shownWhen) => $this$shownWhen.daj($shown);
}
function forEachById$lambda(_this__u8e3s4, it) {
  return Companion_getInstance();
}
var forEachById$OldViewInfoClass;
function forEachById$OldViewInfo() {
  if (forEachById$OldViewInfoClass === VOID) {
    class $ {
      constructor($this_forEachById, $oldEarly, oldIndex, oldId, data, view, shown) {
        this.qdc_1 = $this_forEachById;
        this.rdc_1 = $oldEarly;
        this.kdc_1 = oldIndex;
        this.ldc_1 = oldId;
        this.mdc_1 = data;
        this.ndc_1 = view;
        this.odc_1 = shown;
        this.pdc_1 = 0;
      }
      idc() {
        this.pdc_1 = this.pdc_1 + 1 | 0;
        this.odc_1.oam(true);
      }
      jdc() {
        this.pdc_1 = this.pdc_1 + 1 | 0;
        var n = this.pdc_1;
        this.odc_1.oam(false);
        // Inline function 'kotlin.Long.plus' call
        var this_0 = _Duration___get_inWholeMilliseconds__impl__msfiry(this.ndc_1.mba().vb0_1);
        var tmp = add(this_0, fromInt(100));
        afterTimeout(this.qdc_1, tmp, () => {
          var tmp;
          if (n === this.pdc_1) {
            this.qdc_1.uba(this.ndc_1);
            this.rdc_1.w3(this);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
      }
      toString() {
        return 'OldViewInfo(oldIndex=' + this.kdc_1 + ', oldId=' + toString_0(this.ldc_1) + ', data=' + toString(this.mdc_1) + ', view=' + this.ndc_1.toString() + ', shown=' + toString(this.odc_1) + ')';
      }
      hashCode() {
        var result = this.kdc_1;
        result = imul(result, 31) + (this.ldc_1 == null ? 0 : hashCode(this.ldc_1)) | 0;
        result = imul(result, 31) + hashCode(this.mdc_1) | 0;
        result = imul(result, 31) + hashCode(this.ndc_1) | 0;
        result = imul(result, 31) + hashCode(this.odc_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof forEachById$OldViewInfo()))
          return false;
        if (!(this.kdc_1 === other.kdc_1))
          return false;
        if (!equals(this.ldc_1, other.ldc_1))
          return false;
        if (!equals(this.mdc_1, other.mdc_1))
          return false;
        if (!equals(this.ndc_1, other.ndc_1))
          return false;
        if (!equals(this.odc_1, other.odc_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'OldViewInfo');
    forEachById$OldViewInfoClass = $;
  }
  return forEachById$OldViewInfoClass;
}
var forEachById$4$1Class;
function forEachById$4$1() {
  if (forEachById$4$1Class === VOID) {
    class $ extends ViewWriter() {
      constructor($this_forEachById, $oldPos, $box) {
        if ($box === VOID)
          $box = {};
        $box.ydc_1 = $this_forEachById;
        $box.zdc_1 = $oldPos;
        super($box);
      }
      pc() {
        return this.ydc_1.pc();
      }
      ga2() {
        return this.ydc_1.ga2();
      }
      tba(view) {
        this.ydc_1.sba(this.zdc_1._v, view);
      }
      rba(view) {
        this.ydc_1.rba(view);
      }
    }
    initMetadataForClass($);
    forEachById$4$1Class = $;
  }
  return forEachById$4$1Class;
}
function forEachById$lambda$lambda($shown) {
  return ($this$shownWhen) => $this$shownWhen.daj($shown);
}
function forEachById$lambda$lambda_0($shown) {
  return () => {
    $shown.oam(true);
    return Unit_instance;
  };
}
//region block: exports
export {
  get_atBottom as get_atBottomzb604i67rgu3,
  get_atBottomCenter as get_atBottomCenterphs4xo2ro2dv,
  get_atBottomEnd as get_atBottomEnd1uhyy6gazj2pk,
  get_atBottomStart as get_atBottomStart155elrlt6jm53,
  get_atCenterEnd as get_atCenterEnd17oomnncsh8vk,
  get_atCenterStart as get_atCenterStart2eaw4isrpvpjb,
  get_atEnd as get_atEnd1cw5d2zgug26,
  get_atStart as get_atStart2tgdnaxgj04ln,
  get_atTop as get_atTop15ygil3ceeuhl,
  get_atTopCenter as get_atTopCenter1v6irntzl0tu6,
  get_atTopEnd as get_atTopEnd21ub47e8cwtv6,
  get_atTopStart as get_atTopStart2sqdmdfleu6ji,
  get_centered as get_centered1xfu6or5nc0lq,
  get_empty as get_empty2lwyggrwaqgos,
  get_expanding as get_expanding10cuv3ua9vajx,
  forEachAnimated as forEachAnimated1m511890zq8f5,
  forEachById as forEachById3ln6mzh4mndq4,
  forEachUpdating as forEachUpdating2xo34s2yjc7ia,
  forEach as forEach37zw770vd3h4l,
};
//endregion

//# sourceMappingURL=helpers.mjs.map
